var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutofillDrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02795 6.99999C6.91234 7.00065 6.79773 6.97859 6.6907 6.93507C6.58367 6.89155 6.48632 6.82742 6.40423 6.74637L1.13335 1.49906C0.967933 1.33438 0.875 1.11102 0.875 0.878129C0.875 0.645235 0.967933 0.421879 1.13335 0.257198C1.29877 0.092517 1.52313 0 1.75707 0C1.99101 0 2.21537 0.092517 2.38079 0.257198L7.02795 4.89232L11.6751 0.265944C11.8432 0.122669 12.0593 0.0478021 12.2804 0.0563037C12.5015 0.0648054 12.7112 0.15605 12.8677 0.311803C13.0242 0.467555 13.1158 0.676345 13.1243 0.896448C13.1329 1.11655 13.0577 1.33176 12.9138 1.49906L7.64289 6.74637C7.47926 6.90793 7.25841 6.99902 7.02795 6.99999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutofillDrop);
export default __webpack_public_path__ + "static/media/autofillDrop.717540fd4df134d8b92aa5b900ddf883.svg";
export { ForwardRef as ReactComponent };